import React, { Suspense } from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import './index.css'
import './i18n'

function getBasePath() {
  if (window.location.hostname === 'preview.upcast.social') {
    const match = window.location.pathname.match(/^\/([^/]+)/)
    return match ? `/${match[1]}` : '/'
  }
  return '/'
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Suspense fallback={<div className="min-h-screen bg-slate-950 flex items-center justify-center"><div className="text-slate-400">Loading...</div></div>}>
      <BrowserRouter basename={getBasePath()}>
        <App />
      </BrowserRouter>
    </Suspense>
  </React.StrictMode>
)
